import { render, staticRenderFns } from "./BrazilField.vue?vue&type=template&id=5da88545&scoped=true&"
import script from "./BrazilField.vue?vue&type=script&lang=js&"
export * from "./BrazilField.vue?vue&type=script&lang=js&"
import style0 from "./BrazilField.vue?vue&type=style&index=0&id=5da88545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da88545",
  null
  
)

export default component.exports